










import { Vue, Component } from 'vue-property-decorator';
import { getCreatenList, insertQrcode } from '../api';
import { NewOssSignature } from '@/api/api';
import axios from 'axios';
import * as QRCode from 'qrcode';
import { Toast } from 'vant';

@Component
export default class Home extends Vue {
  showread: boolean = false;
  phone: string = '';
  intonowx: boolean = false;
  indata: any = {};
  qrCode: string = '';
  page: number = 1;
  gobtn: boolean = true;
  async mounted() {
    // this.generateQRCode('https://testdev.cqcb.com/2023h2/CMBYZ0524/home?id=1');
  }
  createQRcode() {
    this.gobtn = false;
    getCreatenList(this.page).then((res: any) => {
      if (res.code === 200) {
        Promise.all(
          res.data.map((item: any) => {
            return this.generateQRCode(
              'https://testdev.cqcb.com/2023h2/CMBYZ0524/home?id=' + item.id,
              item.id,
            );
          }),
        ).then((res1: any) => {
          insertQrcode(JSON.stringify(res1));
        });
        if (res.data.length > 0) {
          this.page = this.page + 1;
          setTimeout(() => {
            this.createQRcode();
          }, 100);
        }
      } else {
        this.page = 1;
        this.gobtn = true;
        Toast('二维码生成完成！');
        return;
      }
    });
  }
  async generateQRCode(qrData: any, id: any) {
    let url = '';
    try {
      const qrCodeOptions = {
        errorCorrectionLevel: 'M',
        type: 'image/png',
        margin: 2,
        scale: 10,
      };
      const thisQRCode = await QRCode.toDataURL(qrData, qrCodeOptions);

      const imgname = qrData.split('=')[1];
      if (!imgname) {
        Toast('参数错误！');
        return false;
      }
      url = await this.convertAndDownload(imgname + '.png', thisQRCode);
    } catch (error) {
      console.log('error::::', error);
    }
    const reurl = id + '|' + url;
    return new Promise((resolve) => {
      resolve(reurl);
    });
  }
  async convertAndDownload(imgname: any, thisQRCode: any) {
    // 创建Blob对象
    const blob = this.base64ToBlob(thisQRCode, imgname, 'image/png');
    const url = await this.uploadOssWithSignature(blob);
    return url;
    // // 创建下载链接
    // const downloadLink = document.createElement('a');
    // downloadLink.href = URL.createObjectURL(blob);
    // downloadLink.download = 'image.png';

    // // 触发下载
    // downloadLink.click();
  }
  base64ToBlob(base64Data: any, fileName: any, contentType: any) {
    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new File(byteArrays, fileName, { type: contentType });
  }
  async uploadOssWithSignature(fileData: any) {
    const ossRes: any = await NewOssSignature();
    const { policy, accessid, callback, signature, host, dir } = ossRes.data;
    const formData = new FormData();
    const name = Math.random() + fileData.name;
    const key = dir + new Date().getTime() + '_' + name;
    formData.append('key', key);
    formData.append('policy', policy);
    formData.append('OSSAccessKeyId', accessid);
    formData.append('success_action_status', '200');
    formData.append('callback', callback);
    formData.append('signature', signature);
    formData.append('name', fileData.name); // 文件名
    formData.append('file', fileData);
    axios({
      url: `https://` + host,
      data: formData,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return process.env.VUE_APP_OSS_NEWEST_IMG + key;
  }
}
